<template>
    <div>
      <h3 class="greenTitle">Últimas configuraciones
        <el-tooltip placement="top">
          <div slot="content">
            Planifica tu ruta utilizando una configuración ya realizada<br/>
          </div>
          <i class="tooltipStyle fa fa-info-circle" aria-hidden="true"></i>
        </el-tooltip>
      </h3>
      <el-form :inline="true" style="height: 60px">
        <el-form-item>
          <el-select  v-model="filter.distribution_centers_id"
                      placeholder="CT"
                      filterable
                      style="width: 300px;"
                      multiple
                      autocomplete
                      no-match-text="No existen coincidencias"
                      no-data-text="Cargando..."
                      clearable>
            <el-option  v-for="ct in data.cts"
                        :key="ct.id"
                        :label="ct.name"
                        :value="ct.id"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="default btnSearch"
                     @click="handleSearch">
            <i class="fa fa-search"/>
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading">
        <el-table :data="dataConfig"
                  size="mini"
                  style="width: 100%;"
                  height="440px"
                  accordion>
          <el-table-column label="ALIAS"
                           min-width="200">
            <template slot-scope="scope">
              <i class="el-icon-star-off"></i>
                <span style="margin-left: 10px">{{ scope.row.alias }}</span>
            </template>
          </el-table-column>
          <el-table-column label="USUARIO"
                           min-width="150"
                           prop="account.email"/>
          <el-table-column min-width="50px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="getConfiguration(scope.row.config)">
                USAR
              </el-button>
            </template>
          </el-table-column>
          <el-table-column min-width="50px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                style="color: #F5A623; margin-left:5px; padding: 10px;"
                icon="el-icon-delete"
                @click="deleteConfigAlias(scope.row.id)">
              </el-button>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template class="asd" slot-scope="props">
              <p class="titleStyle">Fecha de Configuración</p>
              <p class="elementStyle">{{ formatDate(props.row.created_at) }}</p>
              <p class="titleStyle">Horario</p>
              <p class="elementStyle">{{formatHours(props.row.config.time_init)}} a
                {{formatHours(props.row.config.time_finish)}}</p>
              <p class="titleStyle">Empresa</p>
              <p class="elementStyle">{{props.row.config.enterprises_name.join(', ')}}</p>
              <p class="titleStyle">CT</p>
              <p class="elementStyle">{{props.row.config.distribution_centers_name.join(', ')}}</p>
              <p class="titleStyle">Región</p>
              <p class="elementStyle"> {{props.row.config.region_name}}</p>
              <p class="titleStyle">Zonas/s</p>
              <p class="elementStyle"> {{props.row.config.communes_name.join(', ')}}</p>
              <p class="titleStyle">Tipo de documento</p>
              <p class="elementStyle">{{props.row.config.document_types_name.join(', ')}}</p>
              <p class="titleStyle">Tamaño de paquetes</p>
              <p class="elementStyle">{{props.row.config.package_types_name.join(', ')}}</p>
              <p class="titleStyle">Tipo de viaje</p>
              <p class="elementStyle">{{props.row.config.travel_types_name}}</p>
              <p v-if="props.row.config.ctt !== 0" class="titleStyle">CTT</p>
              <p v-if="props.row.config.ctt !== 0" class="elementStyle">Tradis</p>
              <p></p>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="22" :offset="1" class="toolbar">
          <el-pagination layout="total, prev, pager, next"
                         @current-change="handleCurrentChange"
                         :page-size="100"
                         :pager-count="5"
                         :total="totalSize"
                         style="float:right;">
          </el-pagination>
        </el-col>
      </div>
    </div>
</template>

<script>

import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  data() {
    return {
      data: {
        cts: [],
      },
      filter: {
        distribution_centers_id: [],
      },
      dataConfig: [],
      loading: false,
      finish: false,
      totalSize: 0,
    };
  },
  methods: {
    getStatus(parameters = {}) {
      this.loading = true;
      apiRequest(
        {
          module: 'planning',
          service: 'config_planning',
          params: parameters,
        },
      ).then((res) => {
        this.dataConfig = res.data;
        this.totalSize = parseInt(res.headers['x-total-count'], 10);
        this.loading = false;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las configuraciones',
        });
      });
    },
    deleteConfigAlias(id) {
      this.$message({
        message: 'Eliminando configuración, espera un momento',
        duration: 5000,
        showClose: true,
      });
      apiRequest(
        {
          module: 'planning',
          service: 'config_planning_delete',
          pathparam: id,
        },
      ).then(() => {
        this.loading = false;
        this.$notify({
          title: 'OK',
          message: 'Configuración Eliminada',
          type: 'success',
        });
        this.getStatus({ limit: 100 });
        // eslint-disable-next-line no-unused-vars
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar Configuraciones',
        });
      });
    },
    getDistributionCenters() {
      apiRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.cts = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar los CT',
        });
      });
    },
    handleSearch() {
      this.getStatus(this.filter);
    },
    listData(arr) {
      return arr.join(', ');
    },
    getConfiguration(item) {
      this.$emit('useConfig', item);
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatHours(date) {
      return moment(date).format('LT');
    },
    returnMod() {
      this.$router.go(-1);
    },
    getLimitPage(page) {
      return ((page - 1) * 10);
    },
    handleCurrentChange(newPage) {
      this.getStatus({
        offset: this.getLimitPage(newPage),
      });
    },
  },
  beforeMount() {
    this.getStatus({ limit: 100 });
    this.getDistributionCenters();
  },
};
</script>

<style lang="scss" scoped>
.accordionList {
  max-height: 500px;
  overflow: scroll;
}
.collapseTitleStyle {
  padding: 0 2em;
  color: #707070;
  text-transform: uppercase;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  align-items: center;
  p {
    margin: 0 80px 0 0;
    line-height: 50px;
  }
}
.el-input__inner{
  width: 200px;
  height: 40px;
}
.stepContainerStyle {
  max-height: 580px;
  min-height: 580px;
  overflow: scroll;
  width: 100%;
  border: 1px solid #E0E0E0;
  margin-top: 1em;
  padding: 1.5em;
  box-sizing: border-box;
}
.btnSearch{
  height: 40px;
}
.titleStyle {
  margin-left: -40px;
  font-size: 12px;
  color: #AAD500;
  font-weight: 600;
  text-transform: uppercase;
}
.titleStyleRow {
  font-size: 12px;
  color: #AAD500;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 30px 0 0;
}
.tooltipStyle {
  color: #AAD500;
  font-size: 16px;
}
.elementStyle {
  margin: 2px -40px 5px;
  font-size: 12px;
  color: #707070;
  font-weight: 300;
}
.toPlanListStyle {
  line-height: normal;
  border-top: 1px solid #ebeef5;
  padding: 2em 2em 0;
}
.greenTitle {
  font-size: 15px;
  color: #AAD500;
  margin-top: 0px;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 10px;
}
</style>
